<div fxLayout="row" fxLayoutAlign="start start" class="media">
  @if (member) {
    <app-member-picture
      [member]="member"
      class="media-left media-middle member-photo-holder"
    ></app-member-picture>
  }
  <div class="media-body">
    <div class="data-title">
      <app-member-name [member]="member" [class.special]="special"></app-member-name>
      @if (showAge) {
        <span> ({{ getAge() }})</span>
      }
    </div>
    @if (extraData === 'telephoneNumber') {
      <div class="data">
        {{ member.telephoneNumber }}
      </div>
    }
    @if (extraData === 'birthdate') {
      <div class="data">
        {{ member.birthdate | date: "dd-MM-yyyy" || "extern" }}
      </div>
    }
    @if (extraData === 'telephoneNumberAndVegetarian') {
      <div class="data">
        {{ (member.telephoneNumber || "") + " " + isVegetarian() }}
      </div>
    }
    @if (
      extraData !== 'birthdate' &&
      extraData !== 'telephoneNumber' &&
      extraData !== 'telephoneNumberAndVegetarian'
      ) {
      <div
        class="data"
        >
        {{ extraData }}
      </div>
    }
    @if (!member.memberID) {
      <div class="data">Extern</div>
    }
  </div>
</div>
